import "./style.css";
import { useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import {
  addData,
  auth,
  signInUser,
  signUpUser,
} from "../../utils/firebase-config";
import { INDUSTRY, TEACHER } from "../../utils/constants";
import { useNavigate } from "react-router-dom";

export default function RegistrationIndustry(props) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    industry_name: "",
    name: "",
    contact_number: "",
    address: "",
    gender: "",
    email: "",
  });
  const [password, setPassword] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handlePasswordChange = (e, index) => {
    const { name, value } = e.target;
    setPassword({ ...password, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);

    if (
      password.password.trim() === "" ||
      password.confirmPassword.trim() === ""
    ) {
      window.alert("Error: Please fill in all the required fields.");
      return;
    }
    if (password.password.trim() !== password.confirmPassword.trim()) {
      window.alert("Password and confirm Password should be same.");
      return;
    }

    let registrationForm = formData;
    registrationForm.type = INDUSTRY;

    props.loadingStatus(true);
    const user = await signUpUser(registrationForm.email, password.password);

    if (user !== null) {
      await addData(registrationForm);

      window.alert(`You have registered as Industry Visitor.`);
      props.loadingStatus(false);
      navigate("/detail", { state: registrationForm });
    } else {
      props.loadingStatus(false);
      // window.alert(`Error while registering user.`);
    }
  };
  return (
    <form className="registration-form-div" onSubmit={handleSubmit}>
      <div className="form-login">
        <div className="input-field">
          <label>Industry Name</label>
          <input
            className="form-input"
            type="text"
            name="industry_name"
            value={formData.industry_name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Person Name</label>
          <input
            className="form-input"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Contact Number</label>
          <input
            className="form-input"
            type="tel"
            name="contact_number"
            value={formData.contact_number}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Address</label>
          <input
            className="form-input"
            type="tel"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Gender</label>
          <select
            className="form-input"
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className="input-field">
          <label>Email</label>
          <input
            className="form-input"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Password</label>
          <input
            className="form-input"
            type="password"
            name="password"
            value={password.password}
            onChange={handlePasswordChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Confirm Password</label>
          <input
            className="form-input"
            type="password"
            name="confirmPassword"
            value={password.confirmPassword}
            onChange={handlePasswordChange}
            required
          />
        </div>
      </div>

      <button className="submit-btn" type="submit">
        Register
      </button>
      <div style={{ height: "10px" }}></div>
    </form>
  );
}
